import {IdName} from './id-name';

export class Interest extends IdName {

	constructor(id: number, name: string, numSelections: number = 0) {
		super(id, name, numSelections, 1);
	}
}
